export default __webpack_public_path__ + "static/media/unfulfilled-status.71cfda5c.svg";